import * as React from 'react';
import { images } from '../../media';
export var InvertedLogo = function () { return (React.createElement("img", { src: images.smapiotWhite, alt: "smapiot GmbH" })); };
export default InvertedLogo;
//# sourceMappingURL=InvertedLogo.js.map